import { render, staticRenderFns } from "./ShippingReturnForm.vue?vue&type=template&id=2f149328&scoped=true&"
import script from "./ShippingReturnForm.vue?vue&type=script&lang=js&"
export * from "./ShippingReturnForm.vue?vue&type=script&lang=js&"
import style0 from "./ShippingReturnForm.vue?vue&type=style&index=0&id=2f149328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f149328",
  null
  
)

export default component.exports